<template>
  <v-app>
    <v-navigation-drawer
      :mini-variant="!isTabletOrDown"
      :expand-on-hover="!isTabletOrDown"
      :temporary="isMobile"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      class="elevation-5"
    >
      <v-list shaped nav rounded>
        <v-list-item-group
          v-if="!menuLoading"
          mandatory
          v-model="item"
          color="primary"
        >
          <v-list-item
            @click="itemClick(item, i)"
            v-for="(item, i) in roleItems"
            :key="i"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <menu-loader v-else />
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">Blue Business Guide</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      Hi, {{ getUser && getUser.name && getUser.name.replace('_', ' ') }}
      <v-menu left bottom offset-x>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="logout()">
            <v-list-item-icon>
              <v-icon v-text="'mdi-logout-variant'"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Logout'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col v-if="routeRenderError" cols="12" md="8" lg="6">
            <v-alert outlined type="error" class="mb-4">
              This page failed to render. Path: {{ $route.path }}
            </v-alert>
            <v-card outlined class="pa-4">
              <v-card-text class="px-0">
                {{ routeRenderError }}
              </v-card-text>
              <v-card-actions class="px-0">
                <v-btn color="primary" @click="goDashboard"
                  >Go To Dashboard</v-btn
                >
                <v-btn text @click="retryRoute">Retry</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <router-view v-else></router-view>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MenuLoader from '../../loaders/MenuLoader.vue'
import { axios, Functions } from '../../utils'
export default {
  components: { MenuLoader },
  name: 'AdminIndex',
  data: () => ({
    drawer: null,
    item: 0,
    items: [],
    menuLoading: false,
    routeRenderError: ''
  }),

  computed: {
    ...mapGetters(['permissions/getUser', 'permissions/getRole']),
    isTabletOrDown() {
      return this.$vuetify.breakpoint.mdAndDown
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    roleItems: function() {
      if (this['permissions/getRole'] === 'admin') {
        return this.items
      } else {
        return this.items.filter(i => i.adminOnly !== true)
      }
    },
    getUser() {
      return this['permissions/getUser']
    },
    getRole() {
      return this['permissions/getUser']
    }
  },
  methods: {
    ...mapActions([
      'permissions/setUser',
      'permissions/setRole',
      'permissions/setPermissions'
    ]),
    hydrateAuthFromStorage() {
      const storedUser = window.localStorage.getItem('user')
      const storedRole = window.localStorage.getItem('role')
      if (storedUser && !this['permissions/getUser']?.id) {
        try {
          this['permissions/setUser'](JSON.parse(storedUser))
        } catch (err) {
          console.log(err)
        }
      }
      if (storedRole && this['permissions/getRole'] !== storedRole) {
        this['permissions/setRole'](storedRole)
      }
    },
    itemClick(item, i) {
      if (this.$route.path !== item.path) {
        this.$router.push(item.path)
        this.item = i
      }
    },
    goDashboard() {
      this.routeRenderError = ''
      this.$router.push('/dashboard')
    },
    retryRoute() {
      const currentPath = this.$route.fullPath
      this.routeRenderError = ''
      this.$router
        .replace({ path: '/dashboard' })
        .then(() => {
          this.$router.replace({ path: currentPath })
        })
        .catch(() => {
          this.$router.replace({ path: currentPath })
        })
    },
    logout() {
      axios
        .post('logout')
        .then(res => {
          console.log(res.data)
          window.localStorage.removeItem('user')
          window.localStorage.removeItem('role')
          this.$router.push('/login')
        })
        .catch(err => console.log(err))
    }
  },
  errorCaptured(err, vm, info) {
    const message = err && err.message ? err.message : 'Unknown render error.'
    this.routeRenderError = `${message} (${info})`
    return false
  },
  watch: {
    $route() {
      this.routeRenderError = ''
    }
  },
  created() {
    this.hydrateAuthFromStorage()
  },
  mounted() {
    this.menuLoading = true
    axios
      .get('/api/get-dashboard-menu')
      .then(({ data }) => {
        this.items = data
        this.item = Functions.findWithAttr(
          this.roleItems,
          'path',
          window.location.pathname
        )
      })
      .catch(err => console.log(err))
      .finally(() => (this.menuLoading = false))

    console.log('admin index mounted')
    axios
      .get('api/user')
      .then(res => {
        this['permissions/setUser'](res.data)
        this['permissions/setRole'](res.data.roles[0].name)

        axios
          .get('/api/get-sr-permissions')
          .then(({ data }) => this['permissions/setPermissions'](data))
      })
      .catch(err => {
        console.log(err)
        this.$router.push('/login')
      })
  }
}
</script>
